export const openModal = (header, body, callback=null) => ({
    type: 'OPEN_MODAL',
    header,
    body,
    callback
});

export const closeModal = () => ({
    type: 'CLOSE_MODAL',
});